import {Component, ChangeDetectionStrategy} from '@angular/core';
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';

import {Dialog} from '../../../../interfaces/dialog/dialog';
import {SiteConfigRule} from '../../../../models/site-config-rule';
import {LoaderService} from '../../../../services/loader/loader.service';
import {DialogService} from '../../../../services/dialog/dialog.service';
import {SnackbarService} from '../../../../services/snackbar/snackbar.service';
import {DialogParams} from '../../../../interfaces/dialog/dialog-params';
import {SiteConfigRuleService} from '../../../../services/site-config-rule/site-config-rule.service';

@Component({
  selector: 'app-activity-form',
  imports: [
    ReactiveFormsModule
],
  templateUrl: './site-config-form.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './site-config-form.component.scss'
})
export class SiteConfigFormComponent implements Dialog {
  loaded = false;
  siteConfigRule: SiteConfigRule = new SiteConfigRule();
  partnerId: number | null = null;

  form = new FormGroup({
    name: new FormControl('', Validators.required),
    subid: new FormControl(''),
  });

  constructor(
    private loader: LoaderService,
    private dialog: DialogService,
    private snackbar: SnackbarService,
    private siteConfigRuleService: SiteConfigRuleService,
  ) {
  }

  onDialogInit(params: DialogParams): void {
    if (params.data && params.data.id) {
      this.loader.startLoading();
      this.siteConfigRuleService.findOneById(params.data.id).subscribe(siteConfigRule => {
        this.siteConfigRule = siteConfigRule;

        this.partnerId = siteConfigRule.partnerId;

        this.form.patchValue(this.siteConfigRule);
        this.loader.stopLoading();
        this.loaded = true;
      });
    } else if (params.data && params.data.partnerId) {
      this.partnerId = params.data.partnerId;
      this.loaded = true;
    } else {
      this.loaded = true;
    }
  }

  onSubmit(): void {
    if (this.form.invalid) {
      return;
    }

    this.loader.startLoading();

    const params: any = this.form.value;
    params.partnerId = this.partnerId;
    params.accountType = null;
    params.advertisingPlatform = null;

    if (!this.siteConfigRule.id) {
      this.siteConfigRuleService.create(params).subscribe(() => {
        this.snackbar.success('Rule has been created.');
        this.loader.stopLoading();
        this.dialog.closeDialog();
      });
    } else {
      this.siteConfigRuleService.update(this.siteConfigRule.id, params).subscribe(() => {
        this.snackbar.success('Rule has been updated.');
        this.loader.stopLoading();
        this.dialog.closeDialog();
      });
    }
  }

  isCreate(): boolean {
    return !this.siteConfigRule.id;
  }
}
